'use client';
import React, { useState } from 'react';
import { Gift, Check, Zap } from 'lucide-react';
import { toast } from 'sonner';

const dailyRewards = [
  { id: 'dr-1', day: 1, reward: '50 XP', claimed: true },
  { id: 'dr-2', day: 2, reward: '100 XP', claimed: true },
  { id: 'dr-3', day: 3, reward: '₹25', claimed: true },
  { id: 'dr-4', day: 4, reward: '200 XP', claimed: true },
  { id: 'dr-5', day: 5, reward: '₹50', claimed: false, isToday: true },
  { id: 'dr-6', day: 6, reward: '500 XP', claimed: false },
  { id: 'dr-7', day: 7, reward: '$5', claimed: false, isSpecial: true },
];

export default function DailyRewardCard() {
  const [claimed, setClaimed] = useState(false);

  const handleClaim = () => {
    setClaimed(true);
    toast?.success('Daily reward claimed! +₹50 added to your wallet 🎉');
  };

  return (
    <div className="rounded-xl p-4" style={{ background: 'var(--card)', border: '1px solid rgba(245,158,11,0.25)' }}>
      <div className="flex items-center gap-3 mb-4">
        <div className="w-9 h-9 rounded-xl flex items-center justify-center"
          style={{ background: 'rgba(245,158,11,0.2)', border: '1px solid rgba(245,158,11,0.3)' }}>
          <Gift size={18} style={{ color: '#F59E0B' }} />
        </div>
        <div>
          <h3 className="text-sm font-bold text-foreground">Daily Login Reward</h3>
          <p className="text-xs" style={{ color: 'var(--muted-foreground)' }}>Day 5 of 7 streak</p>
        </div>
      </div>
      <div className="grid grid-cols-7 gap-1 mb-4">
        {dailyRewards?.map((reward) => (
          <div
            key={reward?.id}
            className="flex flex-col items-center gap-1"
          >
            <div
              className="w-full aspect-square rounded-lg flex items-center justify-center relative"
              style={{
                background: reward?.claimed
                  ? 'rgba(16,185,129,0.2)'
                  : reward?.isToday
                    ? 'rgba(245,158,11,0.2)'
                    : reward?.isSpecial
                      ? 'rgba(124,58,237,0.15)'
                      : 'var(--muted)',
                border: reward?.isToday
                  ? '1px solid rgba(245,158,11,0.5)'
                  : reward?.isSpecial
                    ? '1px solid rgba(124,58,237,0.4)'
                    : '1px solid var(--border)',
              }}
            >
              {reward?.claimed ? (
                <Check size={10} style={{ color: '#10B981' }} />
              ) : reward?.isToday ? (
                <Gift size={10} style={{ color: '#F59E0B' }} />
              ) : (
                <span style={{ fontSize: '8px', color: 'var(--muted-foreground)' }}>{reward?.day}</span>
              )}
              {reward?.isSpecial && !reward?.claimed && (
                <div className="absolute -top-1 -right-1 w-3 h-3 rounded-full flex items-center justify-center"
                  style={{ background: '#7C3AED', fontSize: '6px', color: '#fff' }}>★</div>
              )}
            </div>
            <span style={{ fontSize: '8px', color: reward?.isToday ? '#F59E0B' : 'var(--muted-foreground)', fontWeight: reward?.isToday ? 700 : 400 }}>
              {reward?.reward}
            </span>
          </div>
        ))}
      </div>
      {!claimed ? (
        <button
          onClick={handleClaim}
          className="btn-primary w-full justify-center py-2 text-sm"
          style={{ background: 'linear-gradient(135deg, #F59E0B, #D97706)' }}
        >
          <Zap size={14} />
          Claim ₹50 Reward
        </button>
      ) : (
        <div className="flex items-center justify-center gap-2 py-2 rounded-lg text-sm font-semibold"
          style={{ background: 'rgba(16,185,129,0.15)', color: '#10B981' }}>
          <Check size={14} />
          Reward Claimed!
        </div>
      )}
    </div>
  );
}